export default {
  "custom": {
    linkedReference: '聯動引用',
    boot: '開機',
    shutDown: '關機',
    notLinked: '未聯動',
    maxLinkedTip: '最多只能有 2 個{type}聯動，已自動恢復為未聯動',

    bar_Power: '電源控制',
    bar_Video: '視訊輸入切換',
    bar_Vol: '音量調節',
    bar_Audio: '音訊切換',
    bar_Serial: '串口控制',
    bar_Air: '空調控制',
    bar_Projection: '幕布控制',
    bar_Remote: '智慧遙控',
    bar_Matrix: 'IQShare Matrix',
    youMustSelectAllThreeImagesAtTheSameTime: '您必須同時選擇三張圖片',
    notSelected: '未選擇',
    choose: '選擇',
    disable: '停用',
    "longPressAndDrag": "長按並拖動調整列表順序",
    "isrestoreDefault": "是否要恢復到預設狀態",
    "saveAndSync": "保存並同步",
    "restoreDefault": "恢復預設",
    "limitPNG": "上傳圖片只能是PNG格式!",
    "limit1M": "上傳圖片大小不能超過 1MB！",
    "selectTheImage": "選擇圖片",
    "textsuggestions": "建議使用尺寸48*48 px，1M以內的白色png圖示",
    "iconLibrary": "圖示庫",
    "panelNavigationBarCustomization": "面板導覽列",
    "logoCustomization": "面板Logo"
  },
  outlook: {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    AuthVerify4004One: '綁定失敗：該微軟租戶（ID:',
    AuthVerify4004Two: "）已被 [",
    AuthVerify4004Three: "]組織占用,如需更換綁定，請先解綁原有組織，或使用不同的微軟租戶。",
    theMicrosoftTenantIsOccupied: '該微軟租戶已被占用',
    Viewtutorial: '查看綁定教程',
    checktenantID: '請檢查您的租戶ID、應用程式ID和應用程式密鑰是否正確。',
    ErrorCode: '錯誤代碼：',
    AuthorizationFailed: '授權失敗',
    Accesshasbeengranted: '已成功授予Microsoft Graph API存取權限',
    successfullyauthorizedDescribe: '所需權限已成功授權。會議室數據將自動同步，請關閉此頁面。',
    Close: '關閉',
    resourceID: '資源ID',
    dialogTips: '提示',
    theAuthorizationIsDeleted: '授權已移除',
    theBindingIsSuccessful: '綁定成功',
    theUnbindingIsSuccessful: '解除綁定成功',
    unbindingFailed: '解除綁定失敗',
    theUnbindingHasBeenUnbound: '已取消解除綁定',
    continueUnbinding: 'Outlook同步將停止，所有即將到來的事件將被清除。繼續解除綁定？',
    areYouSureAboutUnbinding: '所有即將到來的Outlook事件將被清除且同步將停止，此操作無法撤銷。確認解除綁定？',
    UnbindNotSynchronized: '綁定後，此會議室的新Outlook事件將自動同步（過去事件不會同步）',
    unbinding: '解除綁定',
    bindUnableToSelect: '已綁定，無法選擇',
    permissAThird: '請授權綁定第三方資源',
    resourceMailbox: '資源郵箱：',
    PleasecheckID: '授權失敗！請檢查您的租戶ID、應用程式ID和客戶端密鑰是否正確。',
    Waitingforauthorization: '等待授權中...',
    Pleasecompletetheauthorization: 'Microsoft 365登入頁面已開啟，請使用管理員帳號登入以完成授權。',
    pleaseEnterTheTenantID: '請輸入租戶ID',
    pleaseEnterTheClientID: '請輸入應用程式ID',
    pleaseEnterTheClientSecret: '請輸入客戶端密鑰',
    Authorizationcompleted: '授權完成',
    Authorizelogin: '授權Microsoft 365登入',
    ApplicationID: '租戶ID',
    ClientID: '應用程式ID',
    ClientSecret: '客戶端密鑰',
    registTipOne: '請依照',
    registTipTwo: '綁定指南',
    registTipThree: '完成Azure應用程式註冊和權限設定後，再填寫下方欄位。',
    MicrosoftDescribe: '通過綁定Microsoft 365，在Outlook/Teams預訂的會議將自動同步至Q-NEX控制台和會議室預約系統。',
    Addcalendarservice: '日曆同步設定',
    Lasttimesynchronization: '最後同步時間',
    Allocated: '已分配',
    Total: '總數',
    Conferenceroomresources: '會議室資源',
    Bindingtime: '綁定時間',
    Bindtheplatform: '綁定平台',
    Synchronousstate: '同步狀態',
    Organizationname: '組織名稱',
    Bindthirdpartycalendar: '綁定第三方日曆',
    TenantIDTip: 'Azure AD中的唯一識別碼',
    ApplicationIDTip: '在Azure中註冊的應用程式ID',
    ApplicationSecretTip: '在Azure中生成的客戶端密鑰，用於身份驗證'
  },
  meetingManager: {
    IdleDisplayTextTable: '閒置顯示文字',
    IdleDisplayText: '閒置顯示文字：',
    IdleDisplayTextContent: '會議室空閒時顯示的文字（預設：「空閒」）',

    duplicateMeetingRoomName: '會議室名稱重複',
    duplicateMeetingRoomNameContent: '已存在名為「{duplicate_content}」的會議室，請重新輸入。',
    NumberOfRoomPanels: '會議室面板數量',
    Thecurrentterminalhasbeenboundtoanotherorganization: '當前終端已經在其他組織綁定',
    theTerminalNameOrIDIsDuplicated: '面板名稱或id重複',
    theRoomNameOrIDIsDuplicated: '會議室名稱或地點重複',
    AddMeetingRoom: '新增會議室',
    EditMeetingRoom: '編輯會議室',
    MeetingRoomName: '會議室名稱：',
    Location: '地點：',
    ReservationApproval: '預約審批：',
    ApprovalListYes: '是',
    ApprovalListNo: '否',
    Capacity: '容納⼈數：',
    RoomStatus: '會議室狀態：',
    BindRoomDisplay: '面板綁定：',
    meeting_btnAdd: '新增',
    meeting_btnEdit: '編輯',
    meeting_btnBind: '綁定設備',
    meeting_btnDel: '刪除',
    meeting_tableRoomName: '會議室名稱',
    meeting_tableRoomPlace: '地點',
    meeting_tableAppointmentApproval: '預約審批',
    meeting_tableCapacityForPeople: '容納人數',
    meeting_tableMeetingRoomStatus: '會議室狀態',
    meeting_tableAvaliable: '可用',
    meeting_tableOutofService: '停用',
    meeting_tableDoorBind: '門牌綁定',
    meeting_tableBindNPS: '綁定NPS',
    meeting_tableActions: '操作',
    door_theNameOfTheTerminal: '面板名稱：',
    door_deviceID: '面板ID：',
    door_Wallpaper: '壁紙：',
    door_Wallpaper_text: '推薦圖⽚尺⼨:尺⼨ 1280x800， PNG 格式',
    door_bindAMeetingRoom: '綁定會議室：',
    door_table_name: '面板名稱',
    door_table_deviceID: '面板ID',
    door_table_status: '狀態',
    door_table_ipAddress: 'IP地址',
    door_table_bindAMeetingRoom: '綁定會議室',
    door_btnAdd: '新增',
    door_btnBatchAdd: '批量新增',
    door_btnEdit: '編輯',
    door_btnBatchEdit: '批量編輯',
  },

  InputSourcesLinkage: {
    configurationAddTitle: '添加配置',
    configurationEditTitle: '編輯配置',
    dialogConfigName: '配置名稱',
    selectNMPAndNDP: 'NMP/NDP選擇',
    powerControl: '電源控制',
    executeCommand: '執行命令',
    tableConfigName: '配置名稱',
    selectConfig: '請選中配置',
  },
  NPS: {
    Relay: '中繼器',
    RelaySettings: '中繼器設置',
    DevicePower: '設備電源控制',
    DeviceElevation: '升降控制',
    LinageWithNPSPower: '與NPS電源的聯動',
    PresentationSwitch: '展示切換',
    Duplicate: '複製',
    LinkagewithNPSPowe: '與NPS電源聯動',
  },
  PTZ: {
    powerSupplyON: '電源ON',
    powerSupplyOFF: '電源OFF',
    LEFT: '左移',
    RIGHT: '右移',
    UP: '上移',
    DOWN: '下移',
    HOME: 'Home鍵',
    ENLARGE: '放大',
    REDUCTION: '縮小',
    StopMovement: '停止移動操作',
    STOP: '停止縮放操作',
    FOCUS: '自動對焦',
    SET_PRESETS0: '設置預設位0',
    SET_PRESETS1: '設置預設位1',
    SET_PRESETS2: '設置預設位2',
    SET_PRESETS3: '設置預設位3',
    SET_PRESETS4: '設置預設位4',
    SET_PRESETS5: '設置預設位5',
    SET_PRESETS6: '設置預設位6',
    SET_PRESETS7: '設置預設位7',
    SET_PRESETS8: '設置預設位8',
    SET_PRESETS9: '設置預設位9',

    USE_PRESETS0: '調用預設位0',
    USE_PRESETS1: '調用預設位1',
    USE_PRESETS2: '調用預設位2',
    USE_PRESETS3: '調用預設位3',
    USE_PRESETS4: '調用預設位4',
    USE_PRESETS5: '調用預設位5',
    USE_PRESETS6: '調用預設位6',
    USE_PRESETS7: '調用預設位7',
    USE_PRESETS8: '調用預設位8',
    USE_PRESETS9: '調用預設位9',

  },
  schedule: {
    startLinkPowerStart: '電源（CBXs）',
    startLinkPowerStop: '電源（CBXs）',
    dehumidification: '除湿',
    airSupply: '送風',
    masterControl: '主控：',
    powerSupply: '電源',
    RecordingControl: '錄播控制',
    RecordingControlSystem: '錄播系統',
    LiquidCrystal: '液晶',
    projector: '投影儀',
    othertype: '其他',
    lockScreen: '鎖定螢幕',
    childLock: '兒童鎖',
    energySaving: '節能',
    signalSourceSwitching: '訊號來源切換',
    other: '其他功能：',
    otherFunction: '功能',
    send: '發送',
    ON: '開',
    OFF: '關',
    btnAddSchedule: '恢復清單',
    EditSchedulelist: '修改清單',
    AddSchedulelist: '新建清單',
    RestoreSchedulelist: '恢復清單',
    btnCancel: '取消',
    btnNewList: '新建清單',
    ListName: '清單名稱',
    Cannotquit: '強制廣播',
    NOCannotquit: '非強制廣播',
    ListValidityPeriod: '清單有效期',
    ListDescription: '清單描述',
    currentSchedule: '最近清單',
    historySchedule: '歷史清單',
    selectTime: '時間:',
    taskType: '任務類型:',
    selectBroadcasting: '廣播控制',
    selectDeviveControl: '設備控制',
    newSchedule: '新建任務',
    newChecklist: '新建清單',
    titleStatus: '狀態',
    titleType: '類型',
    titleStartTime: '開始時間',
    titleEndTime: '結束時間',
    titleRepeat: '重複方式',
    titleName: '任務名稱',
    titleAction: '操作',
    tableEnabled: '啟用',
    tablePaused: '停止',
    tableEdit: '修改',
    tableDelete: '刪除',
    tableVolumeEdit: '廣播音量',
    tableBroadcastTitle: '廣播標題',
    tableBroadcastContent: '廣播內容',
    tableBroadcastList: '廣播列表',
    tableBroadcast: '廣播方式',
    btnRemoveCompletely: 'Remove completely',
    btnEnabled: '啟用',
    btnPaused: '停止',
    btnDelete: '刪除',
    repeat0: '週一',
    repeat1: '週二',
    repeat2: '週三',
    repeat3: '週四',
    repeat4: '週五',
    repeat5: '週六',
    repeat6: '周日',
    dialogTitleAdd: '新建設備控制',
    dialogTitleEdit: '修改設備控制',
    newBroadcastingSchedule: '新建廣播任務',
    editBroadcastingSchedule: '修改廣播任務',
    chooseDevice: '選擇目標設備',
    timeSetting: '時間設置',
    controlBroadcasting: '廣播選項',
    controlOption: '控制選項',
    scheduleName: '任務名稱:',
    destination: '目標設備:',
    timeTilte: '開始時間:',
    repeatTitle: '重複選項:',
    dialogRepeat0: '週一',
    dialogRepeat1: '週二',
    dialogRepeat2: '週三',
    dialogRepeat3: '週四',
    dialogRepeat4: '週五',
    dialogRepeat5: '週六',
    dialogRepeat6: '周日',
    dialogOnceType: '一次',
    dialogRepeatType: '多次',
    mainPower: '主電源',
    powerControl: '電源控制',
    tableDisplayInputSwitch: '視訊輸入切換',
    tableAirConditioning: '空調',
    tableProjectionScreen: '投影布幕',
    tableElectronicLock: '電子鎖',
    interactiveFlatPanel: 'Interactive Flat Panel',
    displayInputSwitch: '視訊輸入切換：',
    speakerVolume: '喇叭音量',
    MICVolume: '麥克風音量',
    ProjectionScreen: '投影布幕：',
    ElectronicLock: '電子鎖：',
    AirConditioning: '空調',
    AirConditioningPower: '電源:',
    AirConditioningModel: '模式:',
    AirConditioningTEMP: '溫度:',
    AirConditioningFanSpeed: '風速：',
    OPEN: '開',
    CLOSE: '關',
    UP: '升',
    DOWN: '降',
    PowerOFF: '關',
    PowerON: '開',
    ModelAuto: '自動',
    ModelCool: '冷氣',
    ModelHeat: '暖氣',
    ModelAir: '強風',
    TEMPLow: '低',
    TEMPMiddle: '中',
    TEMPHigh: '高',
    btnSave: '儲存',
    btnNext: '下一步',
    StartTime: '開始時間',
    StopTime: '結束時間',
    Mandatory: '是否強制廣播：',
    Video: '視訊廣播',
    Notification: '文字廣播',
    btnFile: '選擇媒體檔案',
    LastingTime: 'Lasting Time',
    textTitle: '標題:',
    textContent: '內容:',
    textTitleLetters: '60字以內',
    textContentLetters: '320字以內',
    CannotquitYES: '是',
    CannotquitNo: '否',
    YES: 'YES',
    No: 'No',
    delTitleContent: '刪除任務清單？',
    delTitleListContent: '刪除的任務清單將移動到歷史清單中，可在歷史清單中恢復',
    deleListTitle: '刪除任務清單？',
    delTitleListContent1: '刪除任務清單將導致與其相關的任務都被清除，請確認。',
    deleListTitle1: '確定刪除該任務清單？',
    delTitle: '確定刪除?',
    btnConfirm: '確認',
    coxAll: '所有任務',
    coxBroadcasting: '廣播控制',
    coxDeviveControl: '設備控制',
    rdMandatory: '強制',
    noRdMandatory: '非強制',
    startDate: '開始日期',
    endedDate: '結束日期',
    or: '-',
    broadcastingType: '廣播類型',
    ChooseTime: '選擇時間',
    ChooseDate: '選擇日期',
    newScheduleList: '新建清單',
    editScheduleList: '修改清單',
    listName: '清單名稱',
    listValidityPeriod: '清單有效期',
    listDescription: '清單描述',
    cancel: '取消',
    confirm: '確認',
    save: '儲存',
    addSuccess: '新增成功！',
    addError: '新增失敗!',
    editSuccess: '編輯成功！',
    editError: '編輯失敗!',
    delSuccess: '刪除成功！',
    delError: '刪除失敗!',
    restoreSuccess: '清單已恢復',
    restoreError: '清單失敗',
    restoreTitleContent: '該時間與清單內時間衝突，請重新選擇',
    Enabled: '啟用',
    Paused: '停止',
    Title: '標題:',
    Content: '內容:',
    errorScheduleNameRequired: '任務名稱不能空白',
    errorDeviceRequired: '請選擇目標設備',
    deleTitle: '確定刪除該任務？',
    loopList: '列表循環',
    errorPleaseDateRange: '請選擇日期區間',
    'addError_2009': '清單名稱重複',
    conflicts: '所要新建的任務與以下任務時間衝突：',
    Pleaseagain: '請重新輸入',
    errorScheduleName: '任務名稱',
    errorListName: '清單名稱',
    'today': '今天',
    'yesterday': '昨天',
    'thisWeek': '本周',
    'lastWeek': '上周',
    'lastMonth': '上月',
    'thisMonth': '本月',
    'times': '次數',
    TimeConflicts: '時間衝突',
    'editError_2006': '查詢不到設備 ',
    'editError_2010': '任務名稱重複',
    ListTimeExpired: '清單時間已過期，請重新選擇',
    TimeExpired: '時間已過期',
    ControlOption: '控制選項未填',
    Pleaseleastone: '請選擇控制選項內容',
    Enter: '請輸入內容',
    TitleFilled: '請填寫標題',
    ContentFilled: '請填寫內容',
    PleaseMediaFile: '請選擇檔',
    PleaseSchedule: '請選擇要操作任務',
    delTitleScheduleContent: '刪除的任務無法恢復',
    deleTitleSchedule: '確定刪除任務嗎？',
    deleteScheduleTitle: '請選擇要刪除的任務',
    PleaseFillColumn: '請填寫清單名稱',
    PleaseDate: '請選擇日期',
    Previous: '上一步',
    RemoteControl: '智能遙控',
    taskhasexpired: '此內容已過期，請聯繫建立人員更新時間',
    execute: '執行',
    broadcastingList: '播放列表',
    volumeSuccess: '音量設定成功',
    volumeFailed: '音量設定失敗',
  },
  Automation: {
    nameDuplicate: '自動任務名稱重複',
    Automation: '⾃動化控制',
    if: '如果:',
    ifContent: '‘如果’部分允許您基於感測器數據設置條件。選擇感測器並指定條件，例如\'溫度 > 26°C\'。',
    then: '則執⾏:',
    thenContent: '‘則執⾏’部分讓您選擇設備並為它們定義操作。選擇設備如NMP1、NMP2並為空調指定操作，例如\'開機+製冷\'。',
    btnDelete: '刪除',
    Add: '新增',
    taskName: '任務名稱',
    dialogTaskName: '任務名稱:',
    Statue: '狀態',
    DevicesApplied: '應⽤設備',
    Operation: '操作',
    AirConditioningPower: '電源:',
    AirConditioningModel: '模式:',
    AirConditioningFanSpeed: '風速：',
    bold: '掃風：',
    selectTask: '請選中任務',
    autoTaskAdd: '新增⾃動化控制任務',
    autoTaskEdit: '編輯⾃動化控制任務',
    Destination: '目標設備',
    selectConditions: '請指定您要執⾏的操作',
    selectDestination: '請選擇⽬標 NMP(s) 設備，然後指定您要執⾏的操作',
    AirConditioningTEMP: '溫度',
    AirConditioningHumidness: '濕度',
    noData: '尚未添加任何任務，請點擊“新增”按鈕進⾏添加',
  },
  rs232Translation: {
    reliveBinding: '解除綁定',
    RELIVEBINDING: '解除綁定',
    ACTO: '雅圖',
    AMENA: 'AMENA',
    APPOTRONICS: '光峰',
    APTI: 'APTI',
    ASEE: '澳視投影機',
    ASK: 'ASK',
    AUCMA: '澳柯瑪',
    AUX: '奧克斯',
    BARCO: '巴可',
    BENQ: '明基',
    BOERKA: '波爾卡',
    BOXLIGHT: '寶視來',
    Canon: '佳能',
    CARRIER: '開利',
    CHANGHONG: '長虹',
    CHIGO: '志高',
    CHRISTIE: '科視',
    Chunlan: '春蘭',
    COSTAR: '中光學',
    CROWN: '皇冠',
    CX: '晨星',
    DAEWOO: '大宇',
    DAIKIN: '大金',
    DIGITEL: 'DP',
    DONGBAO: '東寶',
    EIKI: '愛其',
    electra: '涼宇',
    Electrolux: '伊萊克斯',
    EPSON: '愛普生',
    FEILU: '飛鹿',
    FOUNDER: '方正',
    Frestec: '新飛',
    Fujitsu: '富士通',
    Galanz: '格蘭仕',
    GREE: '格力',
    Haier: '海爾',
    Hisense: '海信',
    HITACHI: '日立',
    HP: '惠普',
    HUIFENG: '匯豐',
    InFocus: '富可視',
    IQ: 'IQ',
    JVC: '勝利',
    KODAK: '可達',
    LANGER: '朗歌',
    LENOVO: '聯想',
    LG: 'LG',
    LITTLESWAN: '小天鵝',
    LUMENS: '捷揚光電',
    McQuay: '麥克維爾',
    Microtek: '中晶',
    Mitsubishi: '三菱',
    NANFENG: '南風',
    NEC: 'NEC',
    OPTOMA: '奧圖碼',
    PALOROID: 'Paloroid',
    panisonic: '松下',
    PHILIP: '飛利浦',
    PJD: '優派',
    PLUS: '普樂士',
    POLAROID: '寶麗來',
    PROPIX: '派克斯',
    PROXIMA: 'Proxima',
    RAYBO: '藍波',
    ROWA: '樂華',
    Samsung: '三星',
    SANYO: '三洋',
    SAST: '先科',
    SEEMILE: '視美樂',
    SHARP: '夏普',
    shengfeng: '勝風',
    Shinco: '新科',
    shuanglu: '雙鹿',
    Sony: '索尼',
    SOVA: '索華'
  },
  VcbEdit: {
    VcbNameNoNull: 'CBX名稱不能空白',
    BrandNoNull: '品牌不能空白',
    ModelNoNull: '型號不能空白',
    AcNoNull: '空調不能空白',
    RcNoNull: '智能遙控不能空白',
  },
  route: {
    customize: '自定義',
    InputSourcesLinkage: '輸入源切換聯働',
    Automation: '自動化任務',
    dashboard: 'Dashboard',
    i18n: 'I18n',
    organizationMge: '群組管理',
    userMge: '用戶管理',
    authorityMge: '操作權限管理',
    roleMge: '身分權限管理',
    equipmentMge: '設備管理',
    workstationMge: '媒體工作站管理',
    cloudDiskMge: '雲端空間管理',
    operationLog: '操作日誌',
    setting: '系統設定',
    resourceMge: '資源管理',
    storageMge: '儲存空間管理',
    interfaceRename: '介面重新命名',
    processorManager: '設備管理',
    projectorCode: '串口編碼管理',
    projectorCodeSetting: '串口編碼設置',
    RepairLog: '報修日誌',
    remoteControl: '智能遙控編碼管理',
    acCode: '空調編碼管理',
    cardMge: '晶片卡管理',
    cardLog: '晶片卡管理日誌',
    cardManager: '晶片卡管理',
    meetingManager: '會議管理',
    meetingRoomManager: '會議室管理',
    meetingDoorManager: '會議室面板管理'
  },
  navbar: {
    logOut: ' 退出',
    dashboard: '後臺管理',
    screenfull: '全螢幕',
    language: '選擇語言',
    userConsole: 'Q-NEX工作臺',
    BackTianwa: '返回天蛙雲',
  },
  feedback: {
    Feedback: '意見回饋',
    email: '請留下電子郵件以便我們快速回覆您的意見和建議',
    content: '歡迎留言幫助我們改善產品功能，感謝您的意見和建議。',
    submit: '送出',
    emailNoEmpty: '電子郵件不能空白',
    emailTrueRule: '請輸入正確的電子郵件格式',
    contentNoEmpty: '內容不能空白',
    feedbackSuccess: '回饋成功',
    feedbackFailed: '回饋失敗',
    emailNoChinese: '電子郵件不能有中文',
    emailLength: '長度在 5 到 100 個字元',
    GroupNameLength: '長度在 1 到 20 個字元',
    emailSpecialString: '此輸入內容不能包含特殊字串'
  },
  login: {
    title: '歡迎回來',
    logIn: '登入',
    username: '用戶名稱',
    password: '密碼',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !',
    placeholder: ["用戶名稱", "密碼", "驗證碼"],
    userNameTitle: '用戶名稱不符!',
    forget: '忘記密碼?',
    loginTitle0: '登入成功!',
    loginTitle1000: '用戶名稱或密碼錯誤!',
    loginTitle1001: '用戶名稱、密碼不能空白!',
    loginTitle1002: '驗收碼不能空白!',
    loginTitle1003: '用戶名稱權限不足，登入失敗!',
    loginTitle1004: '驗證碼錯誤!',
    loginTitle1005: '未登入，請先登入!',
    loginTitleUserName: '用戶名稱不能空白!',
    loginTitlePwd: '密碼不能空白!',
    loginTitleVercode: '驗證碼不能空白!',

    errorLogin: '用戶權限不足不能登入！',
    titleLoginNameFormat: '帳號格式只能輸入字母和數字'
  },
  organizationMge: {
    CanTDragTop: '無法移動至上層根目錄',

    prefixCannotBeEmpty: '超級管理員帳號第一碼不能空白',
    enterEnglishLetters: '超級管理員帳號第一碼只能輸入英文字母和數字',
    dateNotSelected: '服務有效期開始日期未選擇',

    btnAddChild: '新增下層',
    btnAddSibling: '新增同層',
    title: '提示:',
    againTitle: '請再次確認:',
    schoolName: '名稱:',
    type: '類型：',
    sort: '排序:',
    equipmentNum: '設備數量:',
    accountPrefix: '超級管理員帳號:',
    organization: '群組',
    terminalMechanism: '裝置群組',
    organizationNum: '裝置群組數量:',
    adminName: '超級管理員帳號:',
    adminPwd: '超級管理員密碼:',
    realName: '真實姓名:',
    serialNum: '序號:',
    edit: '修改',
    add: '新增',
    del: '刪除',
    addSuccess: '新增成功！',
    addError: '新增失敗!',
    editSuccess: '修改成功！',
    editError: '修改失敗!',
    delSuccess: '刪除成功！',
    delWarn: '群組中有設備，不允許刪除',
    delError: '刪除失敗!',
    copyError: '該流覽器不支援自動複製',
    cancel: '取消',
    confirm: '確認',
    save: '儲存',
    Trial: '試用',
    TrialWorkstation: '您當前為試用狀態。最多只可向三臺裝置發送廣播命令。',
    Normal: '正常',
    NormalWorkstation: '您的服務有效期為',
    to: '至',
    Advent: '臨期',
    AdventWorkstationOne: '您的服務即將於',
    AdventWorkstationTwo: '到期，您的服務已到期，請聯繫您的代理商及時續約。',
    Expired: '逾期',
    ExpiredWorkstation: '您的服務已到期，請聯繫您的代理商及時續約。',
    admin: '超級管理員：',
    serviceState: '服務狀態：',
    serviceStateLIST: '服務狀態',
    ValidityPeriod: '到期時間：',
    ValidityPeriodLIST: '到期時間',
    Trial: '試用',
    Permanent: '永久使用',
    AnnualBilling: '按年計費',
    mediaValidityPeriod: '服務有效期：',
    contactInformation: '聯繫方式（顯示於通知服務續約）',
    company: '公司：',
    email: '電子郵件：',
    phone: '電話：',
    StartDate: '開始日期',
    EndDate: '結束日期',
    To: '至',
    TerminalName: '裝置名稱',
    Competence: '超級管理員',
    operate: '操作',
    statusFilter: '狀態篩選',
    disableStreaming: '確定要停用服務嗎？',
    enableStreaming: '確定要啟用服務嗎？',
    disableStreamingContent: '停用後該群組將無法使用廣播和直播的相關功能。',
    enableStreamingContent: '已過期的群組請注意修改有效期限。',
    search: '輸入群組名稱',
    optionsYearZero: '請選擇',
    optionsYearOne: '一年',
    optionsYearTwo: '兩年',
    optionsYearThree: '三年',

    dialogName: '名稱:',
    detTitle: '刪除該群組將導致它的下層群組及相關資料被刪除，請確認.',
    groupDelTitle: '確認刪除？',
    delTitle: '確認刪除?',
    delTitleContent: '刪除該內容將導致相關資料被刪除，請確認。',
    delCancelButton: '取消',
    delConfirmButton: '確認',
    copySuccess: '內容已複製到剪貼板.',
    error1200: '存在相同名稱的群組',
    error1201: '存在相同名稱的裝置群組名稱或代理群組名稱',
    error1202: '超出最大可連接設備數量',
    error1203: '存在相同名稱的用戶',
    error1204: '在同一層上存在相同名稱的群組',
    error1210: '請輸入管理員密碼',
    warningGroup: '請先選擇一個群組！',
    warningTerminal: 'ˊ裝置群組不能再建立群組！',
    account: '群組名稱重複',
    titleOrganization: '注意：帳號前綴是在組織層級定義的。該組織下的所有使用者帳號都將共用相同的前綴。',

  },
  userMge: {
    nickName: '昵稱',
    contentWithBrand: '輸入品牌或者型號',
    contentwithIp: '輸入設備名稱或者IP地址檢索',
    btnAdd: '新用戶',
    btnDelete: '刪除',
    btnDownload: '下載範本',
    btnImport: '批量導入',
    btnExport: '下載',
    btnDisable: '禁用用戶',
    btnEnable: '啟用用戶',
    accountType: '按身分篩選',
    organizationName: '按群組架構篩選',
    content: '搜尋',

    systemAccount: '用戶ID',
    idCardNumber: '工作代號',
    customizeAccount: '帳號（自定）',
    userName: '姓名',
    licenseNum: '證件號碼',
    phone: '電話',
    email: '電子郵件',
    role: '身分',
    status: '狀態',
    affiliatedOrganization: '群組',
    roleTypeList1: "普通用戶",
    roleTypeList2: "學生",
    roleTypeList3: "家長",
    roleTypeList101: "群組管理員",
    roleTypeList102: "超級管理員",
    roleTypeList301: "超級管理員",
    userStatus1: "使用中",
    userStatus2: "遮罩",
    userStatus3: "刪除",
    operate: '操作',
    dialogName: "昵稱:",
    dialogUserName: "用戶ID:",
    dialogUserNameDefined: "登入名:",
    dialogPassword: "密碼:",
    dialogID: "工作代號:",
    dialogRole: "身分:",
    dialogEmail: "電子郵件:",
    dialogPhone: "電話:",
    dialogGroup: "群組:",
    addUser: '新用戶',
    editUser: '編輯用戶',
    addSuccess: '新增成功！',
    addError: '新增失敗!',
    editSuccess: '修改成功！',
    editError: '修改失敗!',
    delSuccess: '刪除成功！',
    delError: '刪除失敗!',
    cancel: '取消',
    confirm: '確認',
    save: '儲存',
    tableDel: '刪除',
    tableEdit: '編輯',
    selectRoles: '選擇身分',
    delTitle: '確定刪除?',
    delTitleContent: '所選內容將從資料庫中刪除。該操作無法恢復，你確定要繼續嗎?',
    delCancelButton: '取消',
    delConfirmButton: '確認',
    titleRealNameRq: '此項必填',
    titleRealNameFormat: '帳號格式只能輸入字母和數字',
    checkPasswordTitleTwo: '請設置 6 位及以上的密碼，需包含字母和數字，可使用特殊符號（不限制）',
    checkPasswordTitle: '密碼至少6位且不能為純數字',
    titlePhoneFormat: '電話只能填寫數字和()+，-',
    phoneFilled: '電話為必填項目',
    titleEmaileFormat: '電子郵件格式填寫錯誤.',
    emaileFilled: '電子郵件為必填項目.',
    titlUserNameDefinedNub: '用戶名不可超過30個字元',
    titlRealNameNub: '姓名不可超過30個字元',
    titlRealNameField: '姓名為必填項目',
    thisPasswordField: '密碼為必填項目',
    titlPassWordNub: '密碼需在6~30個字元之間',
    selectRecord: '請選擇啟動碼記錄！',
    enableStatus: '啟用',
    stopStatus: '停止',
    enableContent: '是否啟用？',
    stopContent: '是否要停止？',
    error1400: '登入名稱已存在，請重試',
    error1401: '用戶ID 已經存在，操作失敗!',
    error1402: '學校不存在，導入失敗！',
    error1403: '資料錯誤',
    error1404: '操作權限不足',
    selUser: '請選擇用戶！',
    error1900: '查詢不到資料',
    error1610: '請使用超級管理員身分，進行相關操作',
    error1405: '獲取身分失敗',
    error1406: '導入的用戶資料格式不正確',
    error1407: '電子郵件 已經存在，操作失敗',
    error1408: '電話 已經存在，操作失敗',
    errorOrgIdList: '群組不能空白！',
    Bindsucceeded: "關聯成功",
    Bindfailed: '關聯失敗',
    tableuserName: '登入名稱',
    titleDevice: '設備',
    bindDevice: '綁定設備',
    Bindcontrollable: '是否現在關聯可控制設備？',

  },
  devicesMge: {
    mustChooseOne: '開關機聯動，勾選智能遙控時,至少要選擇一個控制命令',
    customName: '自定義名稱',
    testAcCode: '測試空調控製碼',
    Online: '在綫',
    Offline: '離綫',
    unBindConfirm: '确认解除绑定串口',
    unBindConfirm485: '确认解除绑定RS485',
    notYetBoundRS232: '該設備尚未綁定串口編碼，你可以前往設備管理 > 串口編碼管理進行添加',
    RsFollowingFunctions: '通過串口編碼可以實現如下功能：',
    Unbind: '解除綁定',
    Limit255: '檔案名稱不允許超過255個字元',
    clear: '清空',
    equipName: '設備名稱',
    equipType: '類型',
    selectField: '請選擇檔案',
    dialogTip: '*右側無輸入資料時，預設顯示左側內容',
    dialogTipSingle: '*單個設備未命名時，跟隨"ALL"的命名',
    cantDelTemplateOne: '',
    cantDelTemplateTwo: '設備【{deviceName}】下的CBX為模板，確認要刪除嗎？',
    templateTitle: '確認替換範本',
    templateContentOne: '已將設備名稱"',
    templateContentTwo: '"設為CBX的通用範本，確認要將當前設備設為範本嗎？',
    vcbNoTemplateNoSave: '沒有設置範本，無法儲存',
    vcbAcControl: '空調',
    vcbRemoteControl: '智能遙控',
    vcbPOWERControl: '電源控制',
    vcbRS232Control: '串口控制',
    vcbIRControl: '紅外線控制',
    vcbSetting: '的CBX設置',
    editVcb: '編輯CBX',
    vcbName: 'CBX名稱',
    iot: 'CBX控制',
    saveAsTemplate: '設為範本',
    saveAsTemplatereplenish: '選擇多個設備在控制中心中使用該模板',
    Upload: '上傳檔案',
    Select: '選取檔案',
    InputDeviceID: '導入設備碼',
    editNameTips: '* 右側無輸入資料時，預設顯示左側內容',
    "_RS232A": '介面一',
    "_RS232B": '介面二',
    institutionDirectory: '機構目錄',
    projectionScreenLinkageSetting: "投影布幕聯動設置",
    screenLiftingLinkageDisplaySwitch: "布幕升降聯動Display開關:",
    stopLinkage: "停用聯動（幕布需單獨控制)",
    Enable: "啟用聯動（開啟降下，關閉升起)",
    btnAddDevice: '新增設備',
    btnImportDevice: '批量導入設備',
    btnDel: '刪除',
    btnEdit: '編輯',
    tableIpAddress: "IP網址",
    "MACAddress": "MAC位址",
    "firmwareVersion": "韌體版本",
    NA: "N/A",
    tableDeviceName: '設備名稱',
    tableStatus: '狀態',
    tableVideoSwitch: '視訊切換',
    tableAudio: '音訊視訊廣播',
    tablePowerControl: '電源控製',
    tableRS232: '串口控製',
    tableIR: '紅外線控制',
    tableRFIDCard: 'IC卡',
    tableControlPanel: '控制面板',
    tableOrganization: '組織',
    tableActions: '操作',
    dialogAddTitle: '新增設備',
    dialogEditTitle: '編輯設備',
    dialogBatchAddTitle: '批量新增設備',
    dialogBatchEditTitle: '批量編輯設備',
    btnCancel: '取消',
    Devices: '設備:',
    ProjectorCode: '串口編碼:',
    Group: '組織:',
    btnBatchAdd: '批量新增',
    delTitle: '確定刪除?',
    delTitleContent: '所選內容將從資料庫中刪除。該操作無法復原，你確定要繼續嗎？',
    delCancelButton: '取消',
    delConfirmButton: '確認',
    addSuccess: '新增成功！',
    addError: '新增失敗!',
    editSuccess: '編輯成功！',
    editError: '編輯失敗!',
    delSuccess: '刪除成功！',
    delError: '刪除失敗!',
    content: '搜尋',
    cancel: '取消',
    confirm: '確認',
    save: '儲存',
    tableDel: '刪除',
    tableEdit: '編輯',
    selectRoles: '選擇身分',
    selectDevices: '請選擇設備！',
    titleRealNameRq: '此項必填',
    titleRealNameNub: '50字以內',
    titlPassWordNub: '15字以內',
    error1900: '無資料',
    error2000: '超出最大可連接設備數',
    error2001: '導入的設備編碼出錯或暫未錄入到系統中',
    error2002: '導入的設備名稱重複',
    error2003: '導入的設備編碼已經被使用',
    error2004: '導入的資料出錯',
    error2005: '品牌和型號的名稱，與系統中已有數據重複；請重新命名品牌或型號的名稱。',
    error2008: '當前設備已關聯其他群組',
    notDevicesName: '設備名稱不能空白',
    notDevicesNO: '設備編碼不能空白',
    dialogDevicesName: '設備名稱:',
    dialogDevicesID: '設備ID:',
    dialogProjectorCode: '串口編碼:',
    dialogGroup: '組織:',
    dialogSel: '請選擇',
    errorOrgIdList: '組織機構不能空白！',
    errorDevicesName: '設備名稱不能空白！',
    errorDevicesNo: '設備編碼不能空白！',
    dialogTiltleDevices: '設備:',
    uploadSuccess: '上傳成功',
    addSuccess: '新增成功',
    ChooseGroups: '選擇組織',
    ChooseIcon: '選擇圖示',
    dialogDevicesTitle: '資料設定應用到以下設備',
    backDevice: '返回',
    bootSetting: '開機設定',
    nmpOpenSetting: '開機設定',
    npsOpenSetting: '開機設定',
    nmpPowerSettings: '開關機設定',
    npsPowerSettings: '開關機設定',
    nmpInterfaceSettings: '接⼝設定',
    npsInterfaceSettings: '接⼝設定',
    nmpDefaultChannel: 'NMP輸入源設定',
    nmpCloseSetting: '關機設定',
    npsCloseSetting: '關機設定',
    startingUpMethod: '鎖定面板:',
    SwipeToStart: '啟用鎖定（刷卡解鎖）',
    ControlPanelToStart: '停用鎖定（面板無使用限制）',
    Display: '顯示設備',
    External: '外部電源',
    startWith: '開機同步啟動:',
    nmpstartWith: '開機同步啟動:',
    nmpcloseWith: '關機同步關閉:',
    RS232Tip: '當NMP主電源關閉時，包括NMP-串口和最多4個CBX在內的總共5個串口接⼝將收到相應的關機指令碼。',

    startPowerTip: '開機時聯動所有CBX的電源介面設備開啟。',
    startAirTip: '開機時透過設備/CBX紅外線統一開啟所有綁定的空調。',
    startIrTip: '開機時透過設備/CBX紅外線發送聯動指令（如幕布下降、投影機開啟）',
    startRSTip: '開機時透過設備/CBX的串口介面統一發送開機指令',
    CloseDisplayTip: '連接到DISPLAY介面的顯示設備在NDP/NMP關機時會自動關閉。此設定由韌體管理，無法在軟體中變更。',
    CloseExternalTip: '連接到EXTERNAL介面的設備在NDP/NMP關機時會自動關閉。此設定由韌體管理，無法在軟體中變更。',
    ClosePowerTip: '關機時聯動所有CBX的電源介面設備關閉。',
    CloseAirTip: '關機時透過設備/CBX紅外線統一關閉所有綁定的空調。',
    CloseIrTip: '關機時透過設備/CBX紅外線發送聯動指令（如幕布上升、投影機關閉）。',
    CloseRSTip: '關機時透過設備/CBX的串口介面統一發送關機指令。',
    npsOpenRS232Tip: '當主電源開啟時，NPS的兩個串列埠介面將收到相應的開機指令碼。',
    npsRS232Tip: '當主電源關閉時，NPS的2個串口接⼝將收到相應的關機指令碼。',
    useCardTip: '刷卡解鎖後，將⾃動啟動設備主電源。',
    npsCardTip: '刷卡解鎖後，將⾃動啟動設備主電源。',
    PowerOutageHandling: '斷電處理⽅式',
    PowerOutageHandTip: "如果您需要確保在意外斷電時⽼師和學⽣能夠進出教室，請選擇 '斷電開鎖'。否則請選擇 '斷電關鎖' 以限制出⼊。",
    acSetting: '空調控制設置',
    ChooseType: '選擇類型',
    ChooseBrand: '選擇品牌',
    ChooseModel: '選擇型號',
    btnConnectingTest: '連接測試',
    LockSetting: '電子鎖設置',
    ElectricLockType: '電子鎖類型:',
    ElectricLockClosing: '電子鎖關閉方式:',
    PowerUNLOCK: '斷電開鎖',
    PowerLOCK: '斷電關鎖',
    none: '無',
    oddParity: '奇校驗',
    EvenParity: '偶校驗',
    LastSetting: '上次關閉時選擇的通道',
    manualSwitch: '手動開關',
    Auto: '自動關閉（間隔',
    projectorSetting: '設備選擇與綁定',
    baudRate: '串列傳輸速率',
    Parity: '奇偶校驗',
    ON: '電源ON',
    OFF: '電源OFF',
    Channel1: '通道一',
    Channel2: '通道二',
    PowerOffDelay: '關機延時斷電',
    second: '秒',
    DefaultChannel: '主機預設輸入源',
    HDMIA: 'HDMI out A:',
    HDMIB: 'HDMI out B:',
    HDMIC: 'HDMI out C:',
    btnSaveApply: '儲存並應用到其他...',
    btnSave: '儲存',
    btnCustomize: '自定',
    ACIsPowerTitle: '請查看空調是否已開啟？',
    ACIsPowerContent: '請先關閉空調再測試。如未成功開啟，請確認空調品牌和型號是否正確。',
    btnNextModel: '否，測試下一型號',
    btnYes: '確定',
    errorConnecting: '連接測試失敗',
    hot: '熱門',
    '_POWERA': 'Display Power',
    '_POWERB': 'External Power',
    '_MAGNETICLOCK': '電子鎖',
    '_HDMI1': 'HDMI in 1',
    '_HDMI2': 'HDMI in 2',
    '_HDMI3': 'HDMI in 3',
    '_HDMIA': 'HDMI out A',
    '_HDMIB': 'HDMI out B',
    '_HDMIC': 'HDMI out C',
    '_AUDIOA': 'HDMI out A',
    '_AUDIOB': 'Audio IN 1',
    '_AUDIOC': 'Audio IN 2',
    '_AIR': '空調',
    '_USB1': 'USB 1',
    '_USB2': 'USB 2',
    '_USB3': 'USB 3',
    '_USBA': 'USB A',
    '_USBB': 'USB B',
    IRControl: '紅外線控制設置',
    acControlTitle: '空調控制:',
    acControlTitleNew: '空調控制',
    intelligentControlTitle: '智能遙控:',
    intelligentControlTitleNew: '智能遙控',
    btnACControlCode: '識別新空調控制編碼',
    btnAddRemoteControl: '新增新智能遙控編碼',
    ACControlCodeTitle: '識別新空調控制編碼',
    ACControlCodeseft1: "識別空調控制編碼",
    ACControlCodeseft2: "登記空調資訊",
    btnStartIdentify: '開始識別',
    Identifysuccess: '識別成功!',
    BeingIdentify: '正在識別!',
    acBrand: '空調品牌',
    acModel: '空調型號',
    IdentifyFailureTitle: "識別失敗",
    IdentifyFailureContent: '空調控制編碼識別失敗，暫不支持此型號。建議使用智能遙控控制。',
    btnTryAgain: '再試一次',
    btnJump: '跳轉',
    ACrideo: '空調',
    ortherRideo: '其他設備',
    btnBack: '返回',
    btnSortOut: '去整理',
    remoteControlSeft1: '選擇設備類型',
    remoteControlSeft2: '開始學習編碼',
    remoteControlSeft3: '設定資訊',
    addRemoteControlError: '抱歉，可學習的智能遙控編碼條數已滿。請先整理已有的智能遙控編碼。',
    btnPrevious: '上一步',
    btnNextStep: '下一步',
    remoteControlErrorTitle: '學習編碼失敗',
    remoteControlErrorContent1: '1.紅外線發射頭未被遮擋',
    remoteControlErrorContent2: '2.接收器周圍無強光干擾',
    remoteControlErrorContent3: '3.紅外線發射頭安裝無誤',
    remoteControlErrorContent4: '4.遙控器工作正常',
    deviceItem1: '空調',
    deviceItem2: '投影機',
    deviceItem3: '電視',
    deviceItem4: '電風扇',
    deviceItem5: '電燈',
    deviceItem6: '其他',
    deviceItem7: '液晶',
    deviceItem8: '錄播',
    deviceItem9: 'PTZ攝像頭',
    RS232protocol: '串口協議:',
    btnRemoteControl: '開始學習編碼',
    BeingIdentify1: '正在學習!',
    Identifysuccess1: '學習成功!',
    controllerType1: '空調',
    controllerType2: '串口',
    controllerType3: '電視',
    controllerType4: '電風扇',
    controllerType5: '電燈',
    controllerType9: '其他',
    rqRemoteControlCode: '請輸入智能遙控編碼',
    rqBrand: '請輸入空調品牌',
    rqModel: '請輸入空調型號',
    error2016: '智能遙控編碼重複，請重新輸入',
    RS232Setting: '串口設定',
    IR232Setting: 'IR設定',
    SystemError: '系統錯誤，請重試',
    conditionerCodeContent: '未識別到空調編碼，請重試',
    remoteControlCodeContent: '未識別到智能遙控編碼，請重試 ',
    btnRetry: '重試',
    Bindusers: "關聯用戶",
    tablebinduser: '關聯用戶',
    Refresh: '刷新',
    Binduserlable: "是否現在關聯可控制設備的用戶？",
    SaveApplySuccessfully: '儲存並應用成功',
    DeviceType: '類型:',
    tableDeviceType: '類型',
    empty: '暫無資料',
    sendCommand: '延時發送命令',
    enable: '啟用',
    disable: '停用',
    SYNCremoteControl: '啟用開機聯動智能遙控',
    analysisfailed: '識別失敗，請再試一次！',

    CBX: {
      powerSupplyON: '電源ON',
      powerSupplyOFF: '電源OFF',
      powerVcrON: '開始錄播',
      powerVcrOFF: '停止錄播',
      lockScreenON: '鎖定螢幕ON',
      lockScreenOFF: '鎖定螢幕OFF',
      childLockON: '兒童鎖ON',
      childLockOFF: '兒童鎖OFF',
      energySavingON: '節能ON',
      energySaving: '節能',
      energySavingOFF: '節能OFF',
      signalSourceSwitchingON: 'OPS',
      signalSourceSwitchingOFF: 'Android',
      volumeAdjustment: '音量調節',
      brightAdjustment: '亮度調節',
      other: '其他...',
      volumeExample: '範例: 01 02 03 04 05 XX,請根據設備說明書上的提示依次輸入',
      functionCode: '功能:',
      Name: '名稱:',
      controlCode: '控制碼:',
      brand: '品牌:',
      model: '型號:',
      errorBrandName: '品牌不能空白',
      errorModelName: '型號不能空白',
    }


  },
  projectorDevicesMge: {
    "tipOne": "1.填寫功能名稱與控制碼，控制碼示例採用 HEX 格式。",
    "tipTwo": "2.本界面僅做開關機串口命令配置，請至「設備管理/設備/操作/開關機設置」中進行功能啟用。",
    "tipFunctionOne": "1. 可從下拉列表選擇常用功能，智能面板的串口控制界面將顯示對應圖標。",
    "tipFunctionTwo": "2.「POWER ON」和「POWER OFF」命令用於設備開關機串口聯動。本頁僅配置控制碼，聯動功能需前往「設備管理 / 設備 / 操作 / 開關機設置」啟用。",
    ListRS232functions: '串口控制功能列表',
    Customizefunctionlist: '自定功能列表',
    btnAddProjectorCode: '新增串口編碼',
    btnDel: '刪除',
    inputSeach: '搜尋',
    btnEdit: '編輯',
    cancel: '清除',
    confirm: '確認',
    tableName: '名稱',
    tablersType: '設備類型:',
    tablersTypeTable: '設備類型',
    tableModel: '型號',
    tableBrand: '品牌',
    tableActions: '操作',
    dialogAddTitle: '新增串口編碼',
    dialogEditTitle: '編輯串口編碼',
    brand: '品牌:',
    model: '型號:',
    codeName: '名稱:',
    baudRate: '串列傳輸速率:',
    parity: '奇偶校驗:',
    powerOn: '開機碼:',
    powerOff: '關機碼:',
    pgrInput1: '通道一:',
    pgbInput2: '通道二',

    delTitle: '確定刪除?',
    delTitleContent: '所選內容將從資料庫中刪除。該操作無法復原，你確定要繼續嗎',
    delCancelButton: '取消',
    delConfirmButton: '確認',
    content: '搜尋',
    operate: '操作',
    tableDel: '刪除',
    tableEdit: '編輯',
    addSuccess: '新增成功！',
    addError: '新增失敗!',
    editSuccess: '編輯成功！',
    editError: '編輯失敗!',
    delSuccess: '刪除成功！',
    delError: '刪除失敗!',
    selectTitle: '請選擇串口！',
    selectCode: '請選擇串口！',
    none: '無',
    oddParity: '奇校驗',
    EvenParity: '偶校驗',
  },
  roleMge: {
    role1: '普通用戶',
    role101: '代理機構管理員',
    role102: '超級管理員',
    role4: '自定身分',
    roleNew: '新身分',
    btnAddRole: '新建身分',
    RoleName: '身分名稱:',
    chooseUser: '選擇用戶：',
    titleLevel: '廣播權限等級:',
    titleSettings: '操作權限設定:',
    btnSave: '儲存',
    btnDelete: '刪除',
    cancel: '取消',
    confirm: '確認',
    save: '儲存',
    addSuccess: '新增成功！',
    addError: '新增失敗!',
    editSuccess: '編輯成功！',
    editError: '編輯失敗!',
    delSuccess: '刪除成功！',
    delError: '刪除失敗!',
    V3_0_OrganizationManage: '群組管理',
    V3_0_UserManage: '用戶管理',
    V3_0_DeviceManage: '設備管理',
    V3_0_CloudSpaceManage: '雲端空間管理',
    V3_0_OrganizationManage_View: '查詢',
    V3_0_OrganizationManage_Edit: '編輯',
    V3_0_UserManage_View: '查詢',
    V3_0_UserManage_Edit: '編輯',
    V3_0_DeviceManage_AddDevice: '增加設備',
    V3_0_DeviceManage_Operating: '操作',
    V3_0_DeviceManage_Delete: '刪除',
    V3_0_DeviceManage_Edit: '編輯',
    V3_0_CloudSpaceManage_PersonalManage: '個人空間管理',
    V3_0_CloudSpaceManage_PublicManage: '公用空間管理',
    V3_0_CloudSpaceManage_SpaceManage: '雲端空間管理',
    V3_0_CloudSpaceManage_PersonalManage_Operating: '可操作',
    V3_0_CloudSpaceManage_PersonalManage_View: '查詢',
    V3_0_CloudSpaceManage_PublicManage_View: '查詢',
    V3_0_CloudSpaceManage_PublicManage_Upload: '上傳',
    V3_0_CloudSpaceManage_PublicManage_Download: '下載',
    V3_0_CloudSpaceManage_PublicManage_DeleteFile: '刪除檔',
    V3_0_CloudSpaceManage_PublicManage_EditFolder: '編輯檔夾',
    delTitle: '確定刪除?',
    delTitleContent: '所選內容將從資料庫中刪除。該操作無法恢復，你確定要繼續嗎？',
    delCancelButton: '取消',
    delConfirmButton: '確認',
    btnAdd: '新增身分',
    RoleName: '身分名稱:',
    ManageRange: '管理範圍:',
    ChooseUser: '選擇用戶:',
    PermissionSettings: '操作權限設定:',
    BroadcastingPropertyLevel: '廣播優先順序別:',
    ChooseGroups: '選擇群組',
    ChooseTheUser: '選擇用戶',
    deleleTitle: '新身分尚未儲存，離開將刪除該身分，確定離開嗎？',
    Error1601: '不能使用超級管理員',
    Error1602: '獲取身分失敗',
    Error1603: '管理員才有此類功能操作權限',
    Error1604: '身分名稱不能空白',
    Error1605: '機構不能空白',
    Error1606: '該身分已經存在',
    Error1607: '系統定義的身分，不允許修改',
    Error1608: '設定身分失敗',
    Error1609: '系統普通用戶身分，不允許修改',
    Error1610: '請使用裝置管理員身分，進行相關操作',
    Error1611: '不具有相關身分權限',

  },
  authorityMge: {
    V3_0_OrganizationManage: '群組管理',
    V3_0_UserManage: '用戶管理',
    V3_0_DeviceManage: '設備管理',
    V3_0_CloudSpaceManage: '雲端空間管理',
    V3_0_OrganizationManage_View: '查詢',
    V3_0_OrganizationManage_Edit: '編輯',
    V3_0_UserManage_View: '查詢',
    V3_0_UserManage_Edit: '編輯',
    V3_0_DeviceManage_AddDevice: '增加設備',
    V3_0_DeviceManage_Operating: '操作',
    V3_0_DeviceManage_Delete: '刪除',
    V3_0_DeviceManage_Edit: '編輯',
    V3_0_DeviceManage_RepairLog: '報修日誌',
    V3_0_CloudSpaceManage_PersonalManage: '個人空間管理',
    V3_0_CloudSpaceManage_PublicManage: '公用空間管理',
    V3_0_CloudSpaceManage_SpaceManage: '雲端空間管理',
    V3_0_CloudSpaceManage_PersonalManage_Operating: '可操作',
    V3_0_CloudSpaceManage_PersonalManage_View: '查詢',
    V3_0_CloudSpaceManage_PublicManage_View: '查詢',
    V3_0_CloudSpaceManage_PublicManage_Upload: '上傳',
    V3_0_CloudSpaceManage_PublicManage_Download: '下載',
    V3_0_CloudSpaceManage_PublicManage_DeleteFile: '刪除',
    V3_0_CloudSpaceManage_PublicManage_EditFolder: '編輯',
    delTitle: '確定刪除?',
    delTitleContent: '所選內容將從資料庫中刪除。該操作無法復原，你確定要繼續嗎',
    delCancelButton: '取消',
    delConfirmButton: '確認',
    content: '搜尋',
    operate: '操作',
    tableDel: '刪除',
    tableEdit: '編輯',
    addSuccess: '新增成功！',
    addError: '新增失敗!',
    editSuccess: '編輯成功！',
    editError: '編輯失敗!',
    delSuccess: '刪除成功！',
    delError: '刪除失敗!',
    selectTitle: '請選擇串口！'
  },
  workstationMge: {
    priorChoice: '優先選擇:',
    SpeedPriority: '廣播速度優先',
    SyncPriority: '廣播同步優先',
    SpeedPriorityTip: '當廣播指令發出後，接收裝置以較短的緩衝時間執行播放任務，一般緩衝時間在3-5秒。媒體伺服器部署在局域網內的情況下，建議選擇速度優先。',
    SyncPriorityTip: '當廣播指令發出後，所有接收裝置將同步播放廣播內容，一般緩衝時間在8-12秒。',
    btnAddMedia: '新增媒體工作站',
    btnBack: '返回',
    tableMediaLibId: '媒體工作站ID',
    tableMediaLibName: '媒體工作站名稱',
    tableState: '聯網狀態',
    tableBindingUsers: '設定用戶',
    tableLiveAddress: '直播網址',
    tableAddress: '廣播網址',
    tableOperate: '操作',
    tableDel: '刪除',
    tableEdit: '編輯',
    titleMediaStation: '廣播網址:',
    titleLiveStation: '直播網址:',
    radioPublic: '公網',
    radioPrivate: '內網',
    btnSave: '儲存',
    titleUsers: '用戶',
    titleCanBe: '可綁用戶數',
    titleHaveBeen: '已綁用戶數',
    titleMore: '需要新增更多?',
    btnAdd: '新增',
    content: '搜尋',
    tableName: '姓名',
    tableUserName: '用戶名稱',
    operate: '操作',
    affiliatedOrganization: '群組',
    dialogTitle: '新增新媒體工作站',
    dialogTitleEdit: '修改新媒體工作站',
    dialogItemName: '名稱:',
    dialogItemId: 'ID:',
    dialogItemIp: '廣播網址:',
    titleSelectUsers: '選擇用戶',
    selectMedia: '請選擇媒體列表',
    delTitle: '確定刪除?',
    delMediaLibTitle: '確定刪除?',
    delTitleContent: '所選內容將從資料庫中刪除。該操作無法恢復，你確定要繼續嗎？',
    delTitleMediaLibContent: '刪除該內容將導致相關資料都被清除，且無法恢復。',
    delCancelButton: '取消',
    delConfirmButton: '確認',
    selectDevices: '請選擇設備',
    selectUser: '請選擇用戶',
    addUser: '新增用戶',
    editUser: '編輯用戶',
    addSuccess: '新增成功！',
    addError: '新增失敗!',
    editSuccess: '編輯成功！',
    editError: '編輯失敗!',
    delSuccess: '刪除成功！',
    delError: '刪除失敗!',
    cancel: '取消',
    confirm: '確認',
    save: '儲存',
    error2500: '超出當前工作站可連接設備最大數量',
    DeviceName: '設備名稱',
    AssociatedUserManagement: '關聯用戶管理',
    btnDel: '刪除',
    errorMsgId: "找不到該設備ID",
    LiveStreaming: '直播網址:',
    NoFoundMediaId: '搜尋不到媒體工作站的ID',
    AlreadyConnectedOrg: '媒體工作站已關聯其他群組',
    AlreadyBoundMedia: '已有設定媒體工作站，無法繼續設定新的媒體工作站',
    DeleteSecondaryConfirmation: '刪除媒體工作站後資料無法恢復，請二次確認。'
  },
  cloudDiskMge: {
    totalStorage: '總空間',
    GetMore: '獲取更多',
    StorageSpace: '儲存空間',
    Adjustment: '空間調整',
    moreSpace: '獲取更多儲存空間',
    PublicStorage: '公共空間',
    IndividualStorage: '個人空間',
    PublicStorageUsed: '已用公用空間',
    PublicStorageLasted: '剩餘公用空間',
    IndividualStorageUsed: '已用個人空間',
    IndividualStorageLasted: '剩餘個人空間',
    storageSpace: '儲存空間調整',
    tableUserName: '用戶名稱',
    tableUsedSpace: '已用空間',
    tableAvailableSpace: '可用空間',
    tableActiveTime: '上次使用時間',
    tableOperate: '操作',
    cleanup: '提醒用戶清理',
    IndividualStorageSpaceAdjustment: '個人儲存空間調整',
    titleTotal: '儲存空間總大小',
    PublicDisk: '公用空間',
    IndividualDisk: '個人空間',
    PerUser: '/人',
    UsersInTotal: '總用戶數量',
    cancel: '取消',
    confirm: '確認',
    save: '儲存',
    addSuccess: '新增成功！',
    addError: '新增失敗!',
    editSuccess: '編輯成功！',
    editError: '編輯失敗!',
    delSuccess: '刪除成功！',
    delError: '刪除失敗!',
    error3000: '已超過雲端空間大小，操作失敗。',
    error3003: '未設定媒體工作站，此操作失敗。',
    IndividualStorage: '個人空間',
    NoteToCleanup: '通知清理',
    updatePersonalSuccess: '你的雲端空間將滿，請及時清理',
    updatePersonalSuccess1: '修改儲存成功',
    storageUsage: '個人空間使用情況',
    bindIndividualstorage: '可開通個人空間總用戶數量',
    UserIndividualstorage: '已開通個人空間用戶數量',
    Notificationsuccessfully: '已發送通知',
    Notificationfailed: '通知發送失敗',
    tableName: '姓名',
    userID: '用戶ID',
  },
  dashboard: {
    exportPdf: '导出PDF',
    'or': '-',
    'warrantyCompletionRate': '報修完成率',
    'frequencyOfEachModule': '各模組維修頻率',
    'repairHandling': '報修處理情況',
    'sourceSwitchInput': '視訊輸入切換',
    'micVol': '麥克風音量',
    'volumeSpeaker': '喇叭音量',
    'airAonditioner': '空調',
    'Curtain': '布幕',
    'remoteControlIntelligent': '智能遙控',
    'RS232Control': '串口控制',
    'lockElectronic': '電子鎖',
    'Repairreportcompleted': '已完成報修',
    'Totalnumberofrepairsreported': '總報修數量',
    'Warrantycompletionrate': '報修完成率',
    'startDate': '開始日期',
    'endDate': '結束日期',
    'year': '年',
    'month': '月',
    'day': '日',
    dayTian: '日',
    'placeholderDate': '選擇日期',
    'placeholderDateTime': '選擇日期時間',
    'devicesNub': '設備數量',
    'userNub': '用戶數量',
    'powerNub': '用電量(KW/H)',
    'storageUsed': '雲端空間用量(%)',
    'userLoginDevice': '用戶活躍時間',
    'devicePowerConsumption': '總設備用電量',
    'externalDeviceUsageTime': '外接設備使用時間長度',
    'equipmentRunningTime': '裝置運行時間長度',
    'cloudStorageSpace': '存儲空間',
    'powerConsumptionPort': '設備使用次數',
    'mostPopularFile': '常用檔案',
    'commonFunctions': '常用功能',
    'commonlyUsed': '常用廣播方式',
    'fileName': '檔案名稱',
    'usageCount': '使用次數',
    'electricityConsumption': '用電量',
    'publicStorageUsed': '公用空間用量',
    'publicStorageLasted': '公用剩餘空間',
    'individualStorageUsed': ' 私人空間用量',
    'individualStorageLasted': '私人剩餘空間',
    'total': '總量',
    'notification': '文字通知',
    'audioBroadcast': '音訊廣播',
    'videoBroadcast': '視訊廣播',
    'ac': '空調調節',
    'hDMISwitch': '視訊輸入切換',
    'powerControl': '電源控制',
    'powercontrol': '電源控制',
    'Lock': '磁控鎖開關',
    'volumeAdjust': '音量調節',
    'projectionScreen': '布幕升降',
    'today': '今天',
    'yesterday': '昨天',
    'thisWeek': '本周',
    'lastWeek': '上周',
    'lastMonth': '上月',
    'thisMonth': '本月',
    'times': '次數',
    'usage': '功能使用次數',
    'eachrTitle': '分鐘',
    total: '總次數',
    NMPSystemissue: 'NMP系統問題',
    displayPower: 'NMP外接設備問題',
    externalPower: 'MBX系統問題',
    screen: 'MBX外接設備問題',
    TotalRepairs: '全部報修數量',
    Repaired: '已完成保修',
    Unrepaired: '未完成報修',
    day: '天',
    Minutes: '分鐘',
    powerConsumption: '分鐘',
    Date: "日期",
    kw: '千瓦',
    month1: '週一',
    month2: '週二',
    month3: '週三',
    month4: '週四',
    month5: '週五',
    month6: '週六',
    month7: '周日',
    enmonth1: 'Jan',
    enmonth2: 'Feb',
    enmonth3: 'Mar',
    enmonth4: 'Apr',
    enmonth5: 'May',
    enmonth6: 'Jun',
    enmonth7: 'Jul',
    enmonth8: 'Aug',
    enmonth9: 'Sep',
    enmonth10: 'Oct',
    enmonth11: 'Nov',
    enmonth12: 'Dec',
    noData: '暫無資料'
  },
  input: {
    fivedigits: '請輸入5位內的正整數',
    titlUserNameField: '用户名必填',
    thisField: '此項必填.',
    ChooseGroup: '請選擇群組',
    placeholder: '請選擇',
    placeholder_type: '選擇設備控制類型',
    titlRealNameField: '姓名必填',
    thisPasswordField: '密碼必填',
    titlPassWordNub: '密碼需在6~30個字元之間',
    Post: '只能輸入數字',
    passwordNoChinese: '此欄位不能輸入中文',
  },
  transfer: {
    all: '全選',
    Choose: '選擇',
    Selected: '已選',
    Subordinate: '下層'
  },
  setting: {
    limitPngGif: '僅支援 PNG / GIF 格式',
    limit3M: '圖片大小不能超過 3MB',
    setting_door_Wallpaper_text: '建議圖片尺寸：1280x800，PNG 或 GIF 格式',

    reduction: '還原',
    limitJpg: '上傳頭像圖片只能是PNG格式!',
    limit2M: '上傳頭像圖片大小不能超過 2MB!',
    choseFile: '選擇檔案',
    textOne: '1. Logo大小推薦：117*40（圖片格式為PNG）',
    textTwo: '2.上傳成功後，可點擊智能面板Logo位置處進行更新。（智能面板需連接互聯網）',
    customizeLogo: '自定Logo',
    addSuccess: '設定成功！',
    settingIp: '檔空間IP設定',
    ServerIP: 'IP網址:',
    ServerPort: '輸入口:',
    btnSave: '儲存',
    TimeZoneSetting: '時區設定',
    CurrentTime: '當前時間:',
    CurrentTimeZone: '當前時區:',
    httpsSetting: '檔空間網址設定:',
    utcName: '格林威治時間 UTC/GMT',
    utc0: '格林威治時間、英國、里斯本、托爾斯港、倫敦、都柏林、愛丁堡',
    utc0_5: '',
    utc1: '歐洲中部、西非、中非西部、德國、愛爾蘭、法國、阿姆斯特丹、義大利、柏林、羅馬、西班牙、布拉格、貝爾格萊德、布魯塞爾、巴黎、馬德里、 突尼斯、加蓬、摩洛哥',
    utc1_5: '',
    utc2: '非洲東部、俄羅斯、巴格達、科威特、莫斯科、聖彼得堡',
    utc2_5: '',
    utc3: '佛得角、亞速爾群島',
    utc3_5: '伊朗',
    utc4: '阿布扎比、第比利斯、迪拜、毛里求斯、路易港',
    utc4_5: '阿富汗',
    utc5: '巴基斯坦、土庫曼斯坦、馬爾代夫、烏茲別克斯坦、亞美比亞、塔吉克斯坦印度、孟買、新德里、班加羅爾、加爾各答',
    utc5_5: '印度標準時間(印度),斯里蘭卡',
    utc6: '新西伯利亞、吉爾吉斯斯坦、孟加拉國、不丹',
    utc6_5: '澳大利亞科克斯群島,緬甸',
    utc7: '泰國、曼谷、河內、雅加達',
    utc7_5: '',
    utc8: '中國、馬來西亞、菲律賓、新加坡、中國臺灣、中國澳門、中國香港',
    utc8_5: '',
    utc9: '日本、韓國、東京、首爾、札幌、大阪、東帝汶',
    utc9_5: '澳大利亞中部標準時間(北方地區,南澳大利亞州,新南威爾士州斷山)',
    utc10: '澳大利亞、海參崴、關島、坎培拉、墨爾本、悉尼、巴布亞新幾內亞',
    utc10_5: '澳大利亞新南威爾士州豪爵士島',
    utc11: '所羅門群島、庫頁島',
    utc11_5: '澳大利亞諾福克島',
    utc12: '新西蘭、奧克蘭、惠靈頓、斐濟、新西蘭、瑙魯',
    utc12_5: '',
    utc13: '佛得角、亞速爾群島',
    utc13_5: '',
    utc14: '南喬治亞島、費爾南多-迪諾羅尼亞島',
    utc14_5: '',
    utc15: '巴西、聖地牙哥、薩爾瓦多、巴西利亞、烏拉圭、阿根廷、蘇里南',
    utc15_5: '紐芬蘭標準時間(加拿大紐芬蘭-拉布拉多州紐芬蘭島和拉布拉多半島南端部)',
    utc16: '委內瑞拉、玻利維亞、巴拉圭、智利',
    utc16_5: '委內瑞拉',
    utc17: '東部時間(美國和加拿大)、哥倫比亞、多倫多、厄瓜多爾、秘魯、古巴、紐約、漢密爾頓、聖地牙哥',
    utc17_5: '',
    utc18: '美國和加拿大中部時間、墨西哥城、蒙特雷、芝加哥、休斯頓、新奧爾良、孟菲斯',
    utc18_5: '',
    utc19: '山地時間、亞利桑那、馬薩特蘭、鳳凰城、鹽湖城、丹佛、埃德蒙頓',
    utc19_5: '',
    utc20: '太平洋時間、洛杉磯、三藩市、溫哥華、西雅圖、拉斯維加斯',
    utc20_5: '',
    utc21: '阿拉斯加',
    utc21_5: '法屬波利尼西亞馬克薩斯群島',
    utc22: '夏威夷',
    utc22_5: '',
    utc23: '薩摩亞、紐埃島',
    utc23_5: '',
    utc24: '',
  },
  repairLog: {
    DeviceName: '設備名稱:',
    Time: '時間:',
    startDate: '開始時間',
    endedDate: '結束時間',
    or: '-',
    Problem: '問題模組:',
    btnSearch: '搜尋',
    tableNO: 'NO',
    tableDeviceName: '報修設備名稱',
    tableGroup: '群組',
    tableStatus: '狀態',
    tableDeliveredTime: '送出時間',
    tableSubmitter: '送出',
    tableUpdatingTime: '更新時間',
    tableProblem: '問題模組',
    tableAdmin: '負責人',
    tableAdminReply: '回覆',
    tableAttachment: '附件',
    state0: '待解決',
    state1: '處理中',
    state2: '已完成',
    Problem100: '全部',
    Problem0: '系統問題',
    Problem1: '外接設備問題',
    ProblemType: '',
    ProblemType0: '電源控制',
    ProblemType1: '視訊切換',
    ProblemType2: '麥克風音量',
    ProblemType3: '喇叭音量',
    ProblemType4: '空調',
    ProblemType5: '布幕',
    ProblemType6: '電子鎖',
    ProblemType7: '廣播',
    ProblemType8: '紅外線控制',
    ProblemType9: '串口控制',
    dialogDeviceName: '設備名稱:',
    dialogDeviceID: '設備ID',
    dialogGroup: '群組:',
    dialogStatus: '選擇狀態:',
    dialogProblem: '問題模組:',
    dialogNotes: '問題描述:',
    DeliveredTime: '送出時間:',
    UpdatingTime: '更新時間',
    dialogSubmitter: '送出:',
    ITAdmin: '負責人:',
    AdminReply: '回復:',
    Note: '問題描述',
    dialogRepairation: '報修日誌',
    dialogInProcess: '處理中',
    dialogCompleted: '已完成',
    editSuccess: '編輯成功！',
    editError: '編輯失敗!',
    problemRequired: '請選擇問題模組',
    detailRequired: '請描述問題詳情',
    statusRequired: '請選擇問題狀態',
    btnCancel: '取消',
    Detail: '問題詳情',
    controlPanel: '控制面板',
    DeviceType: '類型:',
    dialogDeliveredTime: '送出時間:',
    Submitter: '送出:',
  },
  remoteControl: {
    QuickActionName: '智能遙控名稱',
    DeviceType: '類型',
    Description: '描述:',
    tableDescription: '描述',
    editRemoteControl: '編輯智能遙控編碼',
    QuickActionNameInput: '智能遙控編碼：',
    DescriptionInput: '描述:',
    save: '儲存',
    Brand: '品牌',
    Model: '型號',
    EditACControlCode: '修改空調控制編碼',
    acBrand: '空調品牌',
    acModel: '空調型號'
  },
  card: {
    btnAddCard: '新建卡片',
    btnBatchAddCard: '批量新建卡片',
    tableCard: '卡號',
    tableState: '狀態',
    tableUser: '關聯用戶',
    tableID: '登入名稱',
    tableType: '卡片類型',
    tableFfective: '有效期限',
    dialogCard: '卡號：',
    dialogState: '狀態：',
    dialogUser: '關聯用戶：',
    dialogID: '登入名稱：',
    dialogType: '卡片類型：',
    dialogFfective: '有效期限：',
    dialogRemarks: '備註：',
    dialogAddTitle: '新建卡片',
    dialogEidtTitle: '修改卡片',
    code2201: '卡片的有效期格式設定有誤',
    code2202: '此卡片已經設定',
    code2203: '此用戶已經設定',
    code2204: '此卡片未設定',
    mastCard: '萬用卡',
    regularCard: '普通卡',
    permanent: '永久',
    coxPermanent: '永久',
    coxTime: '一定時間內',
    tableDeviceName: '設備名稱',
    tableDeviceID: '設備ID',
    tableOperating: '操作',
    tableOperatingTime: '操作時間',
    tableCardID: '卡號',
    tableCardType: '卡片分類',
    tabluserName: '用戶名稱',
    tabluserId: '用戶ID',
    unlockPanel: '解鎖面板',
    unlock: '開鎖',
    conAll: '全部',
    btnEnable: '啟用',
    btnDisable: '禁用',
    enableSuccess: '啟用成功',
    stopSuccess: '禁用成功',
    enableError: '啟用失敗',
    stopError: '禁用失敗',
    titlCardField: '卡號不能空白',
    titlCardFieldFormat: '卡號只能輸入字母和數字',
    batchCard: '批量卡號:',
    dialogBachAddTitle: '批量新建卡號',
    pleaseTryAgain1: '卡號錯誤（編號：',
    pleaseTryAgain2: '），請重試',
  },
  privacy: {
    PrivacyPolicy: 'Microsoft Organization Binding Privacy Agreement',
    Byusing: 'Dear User,',
    whatinformation: 'Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking “Agree,” you confirm that you have read and accepted all terms of this agreement.',
    EffectiveDate: 'Effective Date: August 4, 2025',
    title1: 'Required Permissions & Collected Data',
    title1Respects1: 'To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:',
    title1Respects2: 'Delegated Permissions',
    Respects2formation: 'These permissions allow Q-NEX to access your Microsoft account data after login and consent:',
    Respects2formation2: 'Calendars.ReadWrite',
    Respects2formation3: 'Permission Name: Full access to user calendars',
    Respects2formation4: 'Description: Allows the app to create, read, update, and delete events in user calendars.',
    Respects2formation5: 'Purpose: Synchronize personal calendar meetings with the Q-NEX system.',
    Respects2formation6: 'offline_access',
    Respects2formation7: 'Permission Name: Maintain access to data you’ve granted',
    Respects2formation8: 'Description: Allows the app to access authorized data even when you’re not actively using it.',
    Respects2formation9: 'Purpose: Ensures meeting information remains synced even when users are offline.',
    Respects2formation10: 'Openid',
    Respects2formation11: 'Permission Name: Sign in as you',
    Respects2formation12: 'Description: Enables login via work/school accounts and allows the app to read basic profile details.',
    Respects2formation13: 'Purpose: Authenticates user identity for security and associates profiles with meeting data.',
    Respects2formation14: 'Place.Read.All',
    Respects2formation15: 'Permission Name: Read all company places',
    Respects2formation16: 'Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.',
    Respects2formation17: 'Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.',

    tp1: 'Application Permissions (Requires Admin Consent)',
    tp2: 'These permissions enable Q-NEX to sync data automatically without manual reauthorization:',
    tp3: 'Calendars.ReadWrite',
    tp4: 'Permission Name: Read and write calendars in all mailboxes',
    tp5: 'Description: Allows the app to create, read, update, and delete calendar events without user sign-in.',
    tp6: 'Purpose: Syncs schedules from all company meeting room resource mailboxes.',
    tp7: 'Directory.Read.All',
    tp8: 'Permission Name: Read directory data',
    tp9: 'Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.',
    tp10: 'Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.',
    tp11: 'User.Read.All',
    tp12: 'Permission Name: Read all users’ full profiles',
    tp13: 'Description: Allows the app to read user profiles without user sign-in.',
    tp14: 'Purpose: Identifies meeting participants.',
    tp15: 'Place.Read.All',
    tp16: 'Permission Name: Read all company places',
    tp17: 'Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.',
    tp18: 'Purpose: Retrieves full meeting room resource lists and syncs availability statuses.',

    title2: 'Purpose of Data Usage',
    title2Respects1: 'Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.',
    title2Respects2: 'Automatically update room availability to prevent scheduling conflicts.',
    title2Respects3: 'Provide a unified meeting management experience.',

    title3: 'Data Storage & Protection',
    title3Respects1: 'All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.',
    title3Respects2: 'Q-NEX does not share calendar data with third parties unless legally required or for system security.',
    title3Respects3: 'For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.',

    title4: 'Your Rights',
    title4Respects1: 'You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.',

    title5: 'Important Notes',
    title5Respects1: 'Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.',
    title5Respects2: 'Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.',

    contactInformation: 'Contact Information',
    contactInformationContent: 'If you have any questions, please contact: info@qnextech.com',

  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-ft.js